/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createMap } from '../../factoriesAny.js';
export var mapDependencies = {
  typedDependencies: typedDependencies,
  createMap: createMap
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesMap.generated.js
// module id = 508
// module chunks = 0